export default __webpack_public_path__ + "static/media/token-highlight-blue.c365c1d6.svg";